import { SVGProps } from "react";

const IconClose = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            width="11"
            height="11"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            aria-hidden="true"
            {...rest}
        >
            <path d="M4 4l8 8M12 4l-8 8" />
        </svg>
    );
};

export default IconClose;
